import { useContext } from 'react'
import { DictionariesUtils } from '@ocean/utils'
import { DictionariesContext } from 'core/contexts'

const DEFAULT_TIME_ZONE = 'Europe/London'

const useUserTimeZone = () => {
  const { dictionaries } = useContext(DictionariesContext)
  const { timeZones = [] } = dictionaries || {}

  let systemTimeZone: string | undefined
  try {
    systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (e) {
    systemTimeZone = undefined
  }

  const timeZoneId = DictionariesUtils.getItemById(systemTimeZone, timeZones)?.id as string

  return timeZoneId || DEFAULT_TIME_ZONE
}

export default useUserTimeZone
